import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { CancelCondition } from '../models/entities/cancel-condition';
import { UpdateCancelConditionRequest } from '../requests/cancel-conditions/update-cancel-condition.request';
import { StoreCancelConditionRequest } from '../requests/cancel-conditions/store-cancel-condition.request';

@Injectable({
  providedIn: 'root',
})
export class CancelConditionsService {
  constructor(private apiService: ApiService) {}

  create(request: StoreCancelConditionRequest) {
    return this.apiService.post('cancel-conditions', request);
  }

  findAll(): Observable<ApiGetSuccessResponse<CancelCondition[]>> {
    return this.apiService.get('cancel-conditions');
  }

  update(id: number, request: UpdateCancelConditionRequest) {
    return this.apiService.put('cancel-conditions/' + id, request);
  }

  delete(id: number) {
    return this.apiService.delete('cancel-conditions/' + id);
  }
}
